/**
 * @param {HTMLElement} header
 */
export const initHeaderAnnouncement = (header) => {
  const elem = header?.querySelector(".header__announcement");
  const isHiddenClassName = "header__announcement_hidden";

  function toggleShow(show) {
    if (!elem) {
      return;
    }

    if (undefined === show) {
      return toggleShow(!elem.classList.includes(isHiddenClassName));
    }

    elem.classList.toggle(isHiddenClassName, !!show);
  }

  return {
    elem,
    toggleShow,
  };
};
